"use client";

import { useEffect } from "react";
import { trackComparisonPageView } from "@helpers/comparisonPageTracking";

interface ComparisonPageViewTrackerProps {
  additionalProps: Record<string, string>;
}

const ComparisonPageViewTracker = ({
  additionalProps,
}: ComparisonPageViewTrackerProps) => {
  useEffect(() => {
    const windowWithTrackerState = window as typeof window & {
      __ackoComparisonPageViewRoutes?: Set<string>;
    };
    const trackedRoutes =
      windowWithTrackerState.__ackoComparisonPageViewRoutes ||= new Set<string>();
    const routeKey = window.location.pathname;

    if (trackedRoutes.has(routeKey)) {
      return;
    }

    trackedRoutes.add(routeKey);
    trackComparisonPageView(additionalProps);
  }, []);

  return null;
};

export default ComparisonPageViewTracker;
